import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-black border-bg-system-gray-500 pointer-events-none fixed top-0 left-0 z-[-20] h-fit w-full border-b px-[0] py-[16px] opacity-0 transition lg:flex lg:px-[40px] lg:pt-[24px] lg:pb-[16px]',
    showBase: 'pointer-events-auto! z-100! opacity-100!',
    container: 'container flex items-center justify-between lg:gap-[48px]',
    actionWrapper: 'flex items-center gap-[24px] lg:gap-[48px]'
  }
});
